import { Box, FormLabel, TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { RHFAutocomplete } from 'src/components/minimals/form';
import type { TextFieldProps } from '@mui/material/TextField';

type MUISize = TextFieldProps['size'];
type Props = {
  title: string;
  formName: string;
  options: any;
  getOptionLabel: (option: any) => string;
  size: MUISize;
  label: string;
  onChange?: any;
};

export const DropdownItem = ({
  title,
  formName,
  options,
  getOptionLabel,
  size,
  label,
  onChange,
}: Props) => {
  const { setValue } = useFormContext();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <FormLabel sx={{ fontSize: '0.9rem' }}>{title}</FormLabel>
      <RHFAutocomplete
        name={formName}
        disableClearable
        options={options}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={(option, value) => !!option && !!value && option.id === value.id}
        renderInput={(params) => (
          <TextField {...params} fullWidth label={label} sx={{ width: '100%' }} size={size} />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {getOptionLabel(option)}
          </li>
        )}
        onChange={(_, value) => {
          setValue(formName, value.id);
          onChange?.(value);
        }}
      />
    </Box>
  );
};
